import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Link } from '../../api/models/link';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, RouteURLConstants, ServiceURLConstants, UTagConstants } from '../../constants/upplm.constants';
import { LANGUAGES_COUNTRIES_LOCALES } from '../../constants/upplm.constants.dashboard';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { UtagService } from '../../services/upplm.utag.service';

@Component({
    selector: 'confirmation',
    template: require('./confirmation.component.html')
})

export class ConfirmationComponent implements OnInit, AfterViewInit {
    sessionData: SessionResponse;
    public placardId: string = '';
    public documentUrl: string = '';
    public pbDetails: ProgressBarDetails = new ProgressBarDetails();
    public isInitialLoadding: boolean = true;
    public linksForCountry: Link[] = [];
    countryCode: string = '';

    constructor(
        private _commonService: UpsCommonService,
        private _sessionService: UpplmSessionService,
        private _pbService: ProgressBarService,
        private router: Router,
        private _utagService: UtagService,
        private _translateDataPipe: TranslateDataPipe) {
    }

    ngOnInit() {
        this.isInitialLoadding = true;
        this.countryCode = this._sessionService.sessionData.locationDetails.countryKey;
        this._utagService.utagForStartOfTheEvent(UTagConstants.UPPLM_CONFIRMATION_START, UTagConstants.UPPLM_CONFIRMATION_START_SCREEN);
        this.pbDetails = this._pbService.pb;
        this.sessionData = this._sessionService.sessionData;
        this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), this.createSessionRequest()).subscribe((response: SessionResponse) => {
            if (response.commonResponse.isSuccess && response.key) {
                this.sessionData = response;
                this.placardId = this.sessionData.createPickUp.placardId;
                this.documentUrl = this.sessionData.createPickUp.documentUrl;
                this.linksForCountry = [];

                LANGUAGES_COUNTRIES_LOCALES.forEach(item => {
                    if (this.countryCode === item.countryCode && item.showTemporaryPlacard) {
                        const text = `${this._translateDataPipe.transform('upplm.confirmation.viewprint')} (${this._translateDataPipe.transform(item.language)})`;
                        this.linksForCountry.push(new Link(`${this.documentUrl}?loc=${item.locale}`, text));
                    }
                    
                }, this);

                if (this.sessionData.locationDetails) {
                    if (this.sessionData.locationDetails.city == null) {
                        this.goToLocation();
                    }
                }
                this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
                    this._sessionService.mapSessionResponse(response);
                });
            }
            this.isInitialLoadding = false;
        });
    }

    ngAfterViewInit() {
        // do nothing.
    }

    goToLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);
    }

    createSessionRequest(): SessionRequest {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = this.sessionData.locationDetails;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.createPickUp = this.sessionData.createPickUp;
        request.lastTimeSessionReqired = new Date().toString();
        return request;
    }

    closeGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._pbService.pb = new ProgressBarDetails();
            this._pbService.pb.showStatusBar = false;
            this._sessionService.mapSessionResponse(response);
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }
}